import { useTranslation } from "react-i18next";

export default function Legend() {
  const { t } = useTranslation();
  const roles: { key: "verb" | "noun" | "adj" | "prep" | "adverb" | "neutral"; color: string }[] = [
    { key: "verb", color: "var(--frame-verb)" },
    { key: "noun", color: "var(--frame-noun)" },
    { key: "adj", color: "var(--frame-adj)" },
    { key: "prep", color: "var(--frame-prep)" },
    { key: "adverb", color: "var(--frame-adverb)" },
    { key: "neutral", color: "var(--frame-neutral)" },
  ];
  return (
    <div className="legend">
      <div className="legend__group">
        <div className="legend__title">{t("compose.frameColors")}</div>
        <div className="legend__chips">
          {roles.map((r) => (
            <span key={r.key} className="legend__chip" style={{ borderColor: r.color }}>
              <span className="legend__swatch" style={{ background: r.color }} />
              {t(`pos.${r.key}`)}
            </span>
          ))}
        </div>
      </div>

      <div className="legend__group">
        <div className="legend__title">{t("legend.borderTokens")}</div>
        <div className="legend__rows">
          <div>
            <span className="legend__sample" style={{ border: "3px solid var(--frame-noun)" }} />
            {t("legend.single")}
          </div>
          <div>
            <span className="legend__sample" style={{ border: "6px double var(--frame-noun)" }} />
            {t("legend.plural")}
          </div>
          <div>
            <span className="legend__bar">•—</span> {t("tense.past")} · <span className="legend__bar">—•—</span> {t("tense.present")} · <span className="legend__bar">—•</span> {t("tense.future")}
          </div>
          <div>
            ♂ {t("gender.M")} · ♀ {t("gender.F")} · ⚧ {t("gender.NB")}
          </div>
          <div>
            ✕ {t("legend.negation")}
          </div>
          <div>
            + {t("legend.compound")}
          </div>
          <div>
            {t("legend.order")}
          </div>
          <div className="legend__note">
            {t("legend.infinitive")}
          </div>
        </div>
      </div>
    </div>
  );
}
